import {getDistinctCountries, getFirstDossierCountry} from '../../../utils/document';
import {getSubcontractor, getInterventions, getUsers, getDocuments, getArchives, getReminders} from './dataGetters';

export default params => ({
  FETCH_DATA: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING_ALL'});
    let subcontractor;
    try {
      subcontractor = await getSubcontractor(params.subcontractorId);
      dispatch({type: 'UPDATE_SUBCONTRACTOR', subcontractor});
    } catch {
      dispatch({type: 'ERROR', key: 'subcontractor'});
    }

    try {
      const documents = await getDocuments(params.subcontractorId, params.organisationId);
      const dossierCountry = getFirstDossierCountry(
        getDistinctCountries(documents),
        params.organisationCountry,
        subcontractor.country
      );
      dispatch({type: 'UPDATE_DOSSIER_COUNTRY', dossierCountry});
      dispatch({type: 'UPDATE_DOCUMENTS', documents});
    } catch {
      dispatch({type: 'ERROR', key: 'documents'});
    }

    try {
      const archives = await getArchives(params.subcontractorId, params.organisationId);
      dispatch({type: 'UPDATE_ARCHIVES', archives});
    } catch {
      dispatch({type: 'ERROR', key: 'archives'});
    }

    try {
      const {interventions = [], totalCount} = await getInterventions(params);
      dispatch({type: 'UPDATE_INTERVENTIONS', interventions, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'interventions'});
    }

    try {
      const {users = [], totalCount} = await getUsers(params);
      dispatch({type: 'UPDATE_USERS', users, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'users'});
    }

    try {
      const {reminders = [], totalCount} = await getReminders(params);
      dispatch({type: 'UPDATE_REMINDERS', reminders, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'reminders'});
    }
  },
  FETCH_INTERVENTIONS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['interventions']});
    try {
      const {interventions = [], totalCount} = await getInterventions(params);
      dispatch({type: 'UPDATE_INTERVENTIONS', interventions, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'interventions'});
    }
  },
  FETCH_USERS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['users']});
    try {
      const {users = [], totalCount} = await getUsers(params);
      dispatch({type: 'UPDATE_USERS', users, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'users'});
    }
  },
  FETCH_REMINDERS: ({dispatch}) => async () => {
    dispatch({type: 'START_LOADING', keys: ['reminders']});
    try {
      const {reminders = [], totalCount} = await getReminders(params);
      dispatch({type: 'UPDATE_REMINDERS', reminders, totalCount});
    } catch {
      dispatch({type: 'ERROR', key: 'reminders'});
    }
  }
});
